import defineComponent from 'flight';
import NativeAppBetaSignupModalUI from 'static/script/app/ui/beta-signup/native-app-beta-signup-modal-ui';
import InitData from 'static/script/app/data/init-data';
import storage from 'static/script/utils/storage';
import JST from 'static/script/templates/templates';

function NativeAppBetaSignupTriggerUI() {

    this.defaultAttrs({});
    let _sessionStorage = storage.getLocalStorage();
    this._isEligibleIosDevice = function (featureSwitches) {
        if (!featureSwitches['ios-native-beta']) {
            return false;
        }
        return window.Feature.detected.ios && window.Feature.detected['iphone-gte-9'];
    };

    this._isEligibleAndroidDevice = function (featureSwitches) {
        if (!featureSwitches['android-native-beta']) {
            return false;
        }
        return window.Feature.detected['android-mobile'];
    };

    this._storeSignupCompleted = function() {
        _sessionStorage.setItem('native-app-beta-modal-shown', true);
    };

    this._try_open_beta_modal = function(initData)
    {
        let opts = null;

        if (this._isEligibleIosDevice(initData.featureSwitches)) {
            opts = {
                signUpLink: 'https://goo.gl/forms/WHkqcaXgZNrSWr7e2',
                betaOptOutGroup: 'ios-native-beta'
            };

        } else if (this._isEligibleAndroidDevice(initData.featureSwitches)) {
            opts = {
                signUpLink: 'https://goo.gl/forms/Qv6oW95uJGVpaeXp1',
                betaOptOutGroup: 'android-native-beta'
            };
        } else {
            return;
        }

        let content = JST['templates/native-app-beta-modal.html']();
        let payload = {
            cssClass: 'native-app-beta-signup-modal',
            content: content
        };

        this.trigger(document, 'ui:modal:open', payload);
        NativeAppBetaSignupModalUI.attachTo('[data-modal]', opts);
    },

    this.after('initialize', function () {
        let initData = InitData.current();

        if (!initData.isLoggedIn) {
            return;
        }
        if (!initData.featureSwitches) {
            return;
        }

        if (!_sessionStorage) {
            return;
        }

        if (_sessionStorage.getItem('native-app-beta-modal-shown')) {
            return;
        }


        this.on(document, 'data:native-app-beta-signup:submit', this._storeSignupCompleted.bind(this));
        this.on(document, 'data:native-app-beta-optout:submit', this._storeSignupCompleted.bind(this));

        this._try_open_beta_modal(initData);

    });

}

module.exports = defineComponent.component(NativeAppBetaSignupTriggerUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/beta-signup/native-app-beta-signup-trigger-ui.js